import React from 'react';
import _ from 'lodash';
import {
  SpacingBox, H3, H4, ClickableBox,
} from '../../Components';
import { getTranslateByScope } from '../../i18n';
import styles from './ClusterLayout.module.scss';

const translate = getTranslateByScope('clusters');

export const ClusterLayout = ({ clusters, title, onClick }) => {
  const uniqClusters = _.uniq(clusters).sort((a, b) => {
    if (a < b) return -1;
    if (b < a) return 1;
    return 0;
  });

  return (
    <SpacingBox marginTop="lg" marginBottom="md">
      <ClickableBox className={styles.menuItem} onClick={() => onClick(null)}>
        <H3>{title}</H3>
      </ClickableBox>
      <SpacingBox style={{ overflow: 'auto', maxHeight: 200 }} marginTop="lg">
        {uniqClusters.map((clusterName) => (
          <ClickableBox
            key={`cluster-${clusterName}-${title}`}
            className={styles.menuItem}
            onClick={() => {
              onClick(clusterName);
            }}>
            <SpacingBox marginBottom="sm">
              <H4>{translate(clusterName)}</H4>
            </SpacingBox>
          </ClickableBox>
        ))}
      </SpacingBox>
    </SpacingBox>
  );
};

export default ClusterLayout;
